import * as React from "react";
import { useNavigate } from "react-router-dom";
import LinkGuideIcon from "../../icons/LinkGidIcon";
import style from "./LinkGuide.module.scss";
import { ROUTES } from "../../../constants/routes";

export default function LinkGuide() {
  const navigate = useNavigate();

  return (
    <div
      className={style.linkGuide}
      onClick={() => navigate(ROUTES.GID)}
    >
      <LinkGuideIcon />
    </div>
  );
}
